/*
 * Listen to cart changes: cart icon qty text
 */

document.addEventListener("cart:updated", function (evt) {
  const { item_count } = evt.detail.cart;

  const cart_count_el = document.querySelector("[data-js-cart-count-txt]");
  const cart_bubble_count = document.querySelector('cart-count')
  
  if (!cart_count_el) {
    return console.log("Cant fin cart count DOM element");
  }

  cart_bubble_count.classList.remove('hidden');
  cart_count_el.innerHTML = item_count;

  // sizing dropdown cart slider - rebind
  const sizesDropdown = document.querySelectorAll('.cart-drawer [data-js="select-cart-cane-length"]')

  if(sizesDropdown.length === 0){
    console.log("Can't found sized dropdown DOM elements cart slider")
    return;
  }

  let initial = true;
  let updated_key = ''

  sizesDropdown.forEach(size => {
      size.addEventListener('change', async function(e){
        const {value, dataset} = e.target
        const key = dataset.jsCaneLengthSelectKey
        console.log({value, key})
        
        // optimstic UI update
        let prevSize =  document.querySelector(`.cart-drawer [data-js-cane-length-value-key="${key}"]`)

        if(!initial){
          prevSize = document.querySelector(`[data-js-cane-length-value-key="${updated_key}"]`)
          console.log("!initial", prevSize)
        }

        if(!prevSize){
          console.log("Can't found previous size DOM element cart slider")
        }
        //console.log({prevSize, value})
        const formated_value = value.replace(/\*/g, "");
        prevSize.innerText = formated_value

        // Shopify BE update
        const {items} = await getCartData()
        console.log({items})

        if(items.length === 0){
          console.log("Empty cart items cart slider")
          return;
        }

        let updatedItem = items.filter(item => item.key === key)
        if(updatedItem.length === 0){
          console.log("Empty updated item cart slider with latest key ")
          updatedItem = items.filter(item => item.key === updated_key)
          //return;
        }

        //console.log({updatedItem})
        
        const updatedProperties = { ...updatedItem[0].properties, '*Length*': value }
        const payload = {
          id: updatedItem[0].key,
          quantity:  updatedItem[0].quantity,
          properties: updatedProperties
        }
        //console.log({updatedItem, payload})

        //update cart data with new one
        const update = await updateCartData(payload)
        console.log({update})
        
        if(update.status === 'bad_request'){
          return console.log("Failed to update cart size lenght from dropdown")
        }

        // update with new key
        prevSize.setAttribute('data-js-cane-length-value-key', update.items[0].key)
        updated_key = update.items[0].key
        initial = false
        //console.log({updated_key: update.items[0].key})
      })
  })


  // utils
  async function getCartData(){
    try {
      const res = await fetch('/cart.js')
      const data = await res.json()
      return data
    } catch (error) {
      console.log("Failed to fetch cart data", error)
    }
  }

  async function updateCartData(payload){
    try {
      const res = await fetch('/cart/change.js',{
        method:'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      const data = await res.json()
      return data
    } catch (error) {
      console.log("Failed to post cart data", error)
    }
  }

});
